import {RoleEnum} from '@pages/global/users/user-types';
import {WorkspaceResource} from '@workspaces/resources';
import {WorkspaceList, workspacesBasePath} from '@workspaces/workspaces';

const basePath = workspacesBasePath[WorkspaceList.BDESE];
export const subThematicResources: WorkspaceResource[] = [
  {
    name: 'bdese/subthematic',
    list: `${basePath}/subthematics`,
    show: `${basePath}/subthematics/:id`,
    meta: {
      label: 'pages.bdese.labels.subthematic',
      prefix: 'pages.bdese.subthematic',
      accessControl: {
        [RoleEnum.ROLE_ADMIN]: ['list', 'edit', 'delete', 'create', 'show'],
        [RoleEnum.ROLE_USER]: ['list', 'edit', 'delete', 'create', 'show'],
      },
    },
  },
];
